import { fontFamilyRoboto } from '@components/hoc/Theme/Theme.styled';
import { isIpac } from '@config/constants';
import styled from 'styled-components';

export const ButtonWrapper = styled.section`
  text-align: center;
  flex: auto;
  width: 100%;
  height: 55px !important;
  margin: 15px auto 0;
`;

export const Button = styled.button`
  border: 0 !important;
  background: rgb(47, 102, 35);
  color: #ccc;
  font-size: 1rem !important;
  font-family: ${ fontFamilyRoboto };
  line-height: 46px;
  padding: 0 18px;
  border-radius: 25px !important;
  height: 3.2rem;
  cursor: pointer;
  text-align: center;
  box-sizing: border-box;
  display: inline-block;
  opacity: 0.9;
  vertical-align: middle;
  text-decoration: none;
  text-transform: uppercase;
  outline: none;
  text-shadow: none;
  white-space: nowrap;
  width: 130px;

  &:hover {
    opacity: 1;
  }
`;

export const BlueButton = styled(Button)`
  background: ${ isIpac ? '#004c3c' : '#006FFF' } !important;
  color: #fff !important;
`;

export const ContinueButton = styled(BlueButton)`
  font-family: ${fontFamilyRoboto};
  font-size: 16px !important;
  font-weight: 500 !important;
  width: 100%;
  &:disabled {
    opacity: 1;
    background: #ccc !important;
    cursor: not-allowed;
  }
`;
